import React from 'react';
import PropTypes from 'prop-types';
import {Button} from "semantic-ui-react";
import {connect} from "react-redux";
import {openProcessDataConfirmData} from "../../data/fileImport/modalActions";

const ProcessData = (props) => {
    return (
        <Button
            className={`button-process-metrics-data ${props.dataQty}`}
            onClick={(event) => props.dispatch(openProcessDataConfirmData(props.fileDataId, props.metricName, props.dataQty))}
            /*  onClick={(event) => this.processMetricsData(props.fileDataId, props.metricName, props.dataQty)} */
        >
            <i className={`icon icon-status-doc-processing${props.dataQty === 'all' ? '-green' : ''}`}/>
            {props.dataQty === 'all' ? 'Process all' : ''}

        </Button>

    )
};

ProcessData.propTypes = {
    metricName: PropTypes.string,
    fileDataId: PropTypes.number,
    dataQty: PropTypes.string
};

export default connect()(ProcessData);


// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/fileImport/ProcessData.js